import { useFormContext } from 'react-hook-form';
import { Button, ModalDialog } from 'vetrf-ui';
import { EaeuInfo } from 'api/eaeu/types';
import { TransactionItems } from './TransactionItems/TransactionItems';

type ModalContentProps = {
  onClose: () => void;
  onSubmit: (transactionIds: string[]) => void;
  transactions: EaeuInfo[];
};

export const ModalContent = ({ onClose, onSubmit, transactions }: ModalContentProps) => {
  const { getValues } = useFormContext();

  const onSumbit = () => {
    const data = getValues('transactionTypeIdList');
    const array = Object.keys(data).filter((key) => data[key]);

    onSubmit(array);
  };

  return (
    <ModalDialog
      header="Выберите транзакции"
      headerClass="modal-header modal-large"
      onClose={onClose}
      footer={
        <>
          <Button
            color="info"
            icon="check"
            iconColor="white"
            iconSize={100}
            size="sm"
            text="Выбрать"
            onClick={onSumbit}
          />
          <Button
            color="grey"
            icon="times"
            iconColor="white"
            iconSize={100}
            onClick={onClose}
            size="sm"
            text="Закрыть"
          />
        </>
      }
    >
      <TransactionItems transactions={transactions} />
    </ModalDialog>
  );
};
